<!-- <template>
    <div class="container-fluid">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
             <div class="alert alert-info alert-dismissible" id="info">
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                    <h5><i class="icon fas fa-exclamation-triangle"></i> Information</h5>
                    <div id="admission_info"></div>
                </div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><b>Admission For Class XI</b></li>
            </ol>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="card-header p-0 border-bottom-0">
                        <ul class="nav nav-tabs border-primary" id="custom-tabs-four-tab" role="tablist">
                            <li class="nav-item border-left border-right">
                                <a class="nav-link active" id="basicdetails-tab" data-toggle="pill" href="#basicdetails" role="tab" aria-controls="basicdetails" aria-selected="true">Basic Details of Student</a>
                            </li>
                            <li class="nav-item border-left border-right">
                                <a class="nav-link" id="parents_tab-tab" data-toggle="pill" href="#parents_tab" role="tab" aria-controls="parents_tab" aria-selected="false">Ranking Matrix to Schools Applied</a>
                            </li>
                            <li class="nav-item border-left border-right">
                                <a class="nav-link" id="roles-tab" data-toggle="pill" href="#roles" role="tab" aria-controls="roles" aria-selected="false">Admission Details</a>
                            </li>
                            <li class="nav-item border-left border-right">
                                <a class="nav-link" id="programmes-tab" data-toggle="pill" href="#programmes" role="tab" aria-controls="programmes" aria-selected="false">Apply to School</a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content">
                            <!-- <div class="active tab-pane" id="basicdetails"> -->
                            <div class="tab-pane fade show active" id="basicdetails" role="tabpanel" aria-labelledby="basicdetails-tab">
                                <div class="form-group row">
                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                        <table class="table table-sm">
                                            <thead class="bg-info">
                                            </thead>
                                            <tbody>
                                                <template v-if="!is_student">
                                                    <tr>
                                                        <td><span class="text-bold">Student Name</span></td>
                                                        <td>{{ std_admission_details.FirstName}} {{ std_admission_details.MiddleName=='null' ? '': std_admission_details.MiddleName}} {{ std_admission_details.LastName=='null' ? '': std_admission_details.LastName}}</td>
                                                    </tr>
                                                </template>
                                                <template v-else>
                                                    <tr>
                                                        <td><span class="text-bold">Student Name</span></td>
                                                        <td>{{ std_admission_details.Name}} </td>
                                                    </tr>
                                                </template>
                                                <tr>
                                                    <td><span class="text-bold">Date of Birth</span></td>
                                                    <td>{{std_admission_details.DateOfBirth}}</td>
                                                </tr>
                                                <tr>
                                                    <td><span class="text-bold">Dzongkhag</span></td>
                                                    <!-- <td>{{dzongkhagArray[std_admission_details.CmnDzoId]}}</td> -->
                                                    <td>{{this.student_form.dzongkhagName}}</td>
                                                </tr>
                                                <tr>
                                                    <td><span class="text-bold">Village</span></td>
                                                    <td>{{villageArray[std_admission_details.CmnChiwogId]}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                        <table class="table table-sm">
                                            <thead class="bg-info">
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><span class="text-bold">CID</span></td>
                                                    <td>{{std_admission_details.CidNo}}</td>
                                                </tr>
                                                <tr>
                                                    <td><span class="text-bold">Date of Birth</span></td>
                                                    <td>{{std_admission_details.DateOfBirth}}</td>
                                                </tr>
                                                <tr>
                                                    <td><span class="text-bold">Gewog</span></td>
                                                    <td>{{gewogArray[std_admission_details.CmnGewogId]}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="tab-pane" id="parents_tab" aria-labelledby="parents_tab" > -->
                            <div class="tab-pane fade" id="parents_tab" role="tabpanel" aria-labelledby="parents_tab-tab">
                                 <div class="card">
                                    <label class="card-header"><strong>Ranking Information for Each School</strong></label>
                                    <table class="table table-bordered table-striped" id="OrgDetails">
                                        <thead>
                                            <tr>
                                                <th>School Name (<i class="fa fa-fw fa-arrow-down"></i>) / Stream (<i class="fa fa-fw fa-arrow-right"></i>)</th>
                                                <th>Arts</th>
                                                <th>Commerce</th>
                                                <th>Science</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="record2" v-for='(item, index) in positionResult' :key="index">
                                                <td>{{item.name}}</td>
                                                <td>
                                                    {{StreamName[item.Arts.strm]==  'Arts' ? item.Arts.rank : "NA"}}
                                                </td>
                                                <td>
                                                    {{StreamName[item.Commerce.strm]==  'Commerce' ? item.Commerce.rank : "NA"}}
                                                </td>
                                                <td>
                                                    {{StreamName[item.Science.strm]==  'Science' ? item.Science.rank : "NA"}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="tab-pane" id="roles" aria-labelledby="roles-tab">
                                <div class="card">
                                    <label class="card-header"><strong>Application Status</strong></label>
                                    <table class="table table-bordered table-striped" id="OrgDetails">
                                        <thead>
                                            <tr>
                                                <th>Name of School</th>
                                                <th>Stream</th>
                                                <th>School Decision</th>
                                                <th>Student Decision</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="record1" v-for='(item, index) in response_data' :key="index">
                                                <td>{{item.organization.name}}</td>
                                                <td>{{StreamName[item.stream_id]}}</td>
                                                <td>{{item.school_decision}}</td>
                                                <td>{{item.student_decision}}</td>
                                                <td>
                                                    <template v-if="item.school_decision!='Accepted' && item.school_decision!='Rejected' && item.student_decision!='Accepted' && item.student_decision!='Rejected'">
                                                        <template v-if="StreamName[item.stream_id]==='Science'">
                                                            <template v-if="(this.from_date > this.currentDate) && (this.to_date < this.currentDate) ">
                                                                <button type="button" class="btn btn-flat btn-sm bg-success" id="remove"
                                                                @click="remove('Rejected',item.id)"><i class="fa fa-times pr-2"></i> Reject</button>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="general_date >= present_date">
                                                                <button type="button" class="btn btn-flat btn-sm bg-success" id="remove"
                                                                @click="remove('Rejected',item.id)"><i class="fa fa-times pr-2"></i> Reject</button>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="item.school_decision=='Accepted' && item.student_decision!='Accepted'">
                                                        <template v-if="StreamName[item.stream_id]==='Science'">
                                                            <template v-if="(this.from_date > this.currentDate) && (this.to_date < this.currentDate)">
                                                                <button type="button" class="btn btn-flat btn-sm btn-primary" id="remove"
                                                                @click="remove('Accepted',item.id)"><i class="fa fa-check"></i> Accept</button>
                                                                <button type="button" class="btn btn-flat btn-sm bg-success" id="remove"
                                                                @click="remove('Rejected',item.id)"><i class="fa fa-times pr-2"></i> Reject</button>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="general_date >= present_date">
                                                                <button type="button" class="btn btn-flat btn-sm btn-primary" id="remove"
                                                                @click="remove('Accepted',item.id)"><i class="fa fa-check"></i> Accept</button>
                                                                <button type="button" class="btn btn-flat btn-sm bg-success" id="remove"
                                                                @click="remove('Rejected',item.id)"><i class="fa fa-times pr-2"></i> Reject</button>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <!-- <template v-else-if="item.school_decision=='Accepted' && item.student_decision=='Accepted'">
                                                        
                                                    </template> -->
                                                    <template v-if="item.school_decision==''">
                                                        <button type="button" class="btn btn-flat btn-sm btn-danger" id="remove"
                                                        @click="remove('Remove',item.id)"><i class="fa fa-trash"></i> Remove</button>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="tab-pane" id="programmes" aria-labelledby="programmes-tab">
                                <div class="card-body">
                                    <div class="form-group">
                                    <h5>Apply for Admission</h5>
                                        <div class="alert alert-info alert-dismissible" id="admission_info">
                                            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                                            <h5><i class="icon fas fa-exclamation-triangle"></i> Information</h5>
                                            <div id="admission_message"></div>
                                        </div>
                                        <template v-if="!admission_closed">
                                            <form id="" class="form-horizontal" enctype="multipart/form-data" action="#" method="POST">
                                                <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12" id="selectschool">
                                                    <table id="dynamic-table" class="table table-sm table-bordered table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>Dzongkhag/Thromde</th>
                                                                <th>School</th>
                                                                <th>Class</th>
                                                                <th>Stream</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr id="record1" v-for='(item, index) in response_data' :key="index">
                                                                <td>{{dzongkhagArray[item.Dzongkhagid]}}</td>
                                                                <td>{{item.organization.name}}</td>
                                                                <td>XI</td>
                                                                <td>{{StreamName[item.stream_id]}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <select name="dzongkhag" @change="getschoolList('dzongkhag'),removeerror('dzongkhag')" :class="{ 'is-invalid': student_form.errors.has('dzongkhag') }" v-model="student_form.dzongkhag" class="form-control" id="dzongkhag">
                                                                        <option value="">--- Please Select ---</option>
                                                                        <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{item.name}}</option>
                                                                    </select>
                                                                    <has-error :form="student_form" field="dzongkhag"></has-error>
                                                                </td>
                                                                <td>
                                                                    <select v-model="student_form.school" :class="{ 'is-invalid': student_form.errors.has('school') }" @change="getstreamList(),removeerror()" class="form-control" name="school" id="school">
                                                                        <option value="">--- Please Select---</option>
                                                                        <option v-for="(item, index) in schoolList" :key="index" v-bind:value="item.id">{{item.name}}</option>
                                                                    </select>
                                                                    <has-error :form="student_form" field="school"></has-error>
                                                                </td>
                                                                <td>
                                                                    <span>{{this.std_class}}</span>
                                                                </td>
                                                                <td>
                                                                    <select v-model="student_form.stream" :class="{ 'is-invalid': student_form.errors.has('stream') }"   @change="checkStream(),removeerror()" class="form-control" name="stream" id="stream">
                                                                        <option value="">--- Please Select---</option>
                                                                        <option v-for="(item, index) in streamList" :key="index" v-bind:value="item.id">{{item.stream}}</option>
                                                                    </select>
                                                                    <has-error :form="student_form" field="stream"></has-error>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan='5'>
                                                                    <button type="button" class="btn btn-flat btn-sm btn-primary" id="addMore"
                                                                    @click="addMore()"><i class="fa fa-plus"></i> Save & Add</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </form>
                                            <hr>
                                            <div class="row form-group fa-pull-right" id="finalbtn" style="display:none">
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <button class="btn btn-flat btn-primary" @click="submitDetail()"> <i class="fa fa-save"></i> submit</button>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            is_student:false,
            xi_admission_type:'',
            adm_start_date:'',
            adm_end_date:'',
            present_date:'',
            from_date:'',
            currentDate: new Date(),
            general_date:'',
            admission_closed:false,
            is_admitted:'',
            std_id:'',
            std_class:'XI',
            org_id:'',
            scholarship_number:'',
            parent_school_dzongkhag:'',
            StreamName:{},
            genderArray:{},
            dzongkhagArray:{},
            gewogArray:{},
            villageArray:{},
            OrgDetails:'',
            dzongkhagList:[],
            schoolList:[],
            classList:[],
            streamList:[],
            scienceQualification:{},
            artsQualification:{},
            commerceQualification:{},
            scienceGrades:{},
            artsGrades:{},
            commerceGrades:{},
            std_admission_details:'',
            ppdob:'',
            eccddob:'',
            ppmonth:'',
            eccdmonth:'',
            response_data:[],
            positionResult:[],
            student_form: new form({
                id:'',
                seats:0,
                admission_type:'',
                student_id:'',
                dzongkhag:'',
                dzongkhagName:'',
                school:'',
                class:'',
                stream:'',
                dateOfapply:'',
                remarks:'',
                std_decission:'',
                actiontype:'portal'
            })
        }
    },
    methods:{
         /**
         * method to add more fields
         */
        addMore: function(){
            Swal.fire({
                text: "Are you sure you wish to save this details ?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
            }).then((result) => {
                if(result.isConfirmed){
                    this.student_form.class = this.std_class;
                    this.student_form.post('/admissions/saveorgclassDetails')
                    .then((response) => {
                        this.student_form.dzongkhag=this.parent_school_dzongkhag;
                        this.student_form.school='';
                        this.student_form.class='';
                        this.student_form.stream='';
                        // this.loadadmissions();
                    })
                    .catch((error) => {
                        console.log("Error addMore:"+error);
                    })
                }
            });
        },
        loadStreamList(uri = 'organizations/loadStreamList'){
            axios.get(uri)
            .then(response => {
                let data = response.data;
                for(let i=0;i<data.length;i++){
                    this.StreamName[data[i].id] =data[i].stream;
                }
            })
            .catch(function (error) {
                if(error.toString().includes("500")){
                    $('#tbody').html('<tr><td colspan="6" class="text-center text-danger text-bold">This server down. Please try later</td></tr>');
                }
            });
        },
        // loadadmissions(){
        //     let std_id=this.student_form.student_id;
        //     this.student_form.student_seats=[];
        //     let from_date = this.adm_start_date;
        //     let end_date = this.adm_end_date;

        //     axios.get('/admissions/getorgclassDetails/'+from_date+'/'+end_date+'/'+std_id)
        //     .then(Response =>{
        //         let data = Response.data;
        //         // alert(JSON.stringify(data));
        //         this.response_data=data;

        //         if(data.length>0){
        //             $('#finalbtn').show();
        //         }
        //     }).catch(error => console.log(error));
        // },

        // getScholarshipRanking(){
        //     let std_id=this.student_form.student_id;
        //     let from_date = this.adm_start_date;
        //     let to_date = this.adm_end_date;
        //     axios.get('/admissions/getScholarshipRanking/'+from_date+'/'+to_date+'/'+std_id)
        //     .then(Response =>{
        //         let data = Response.data;
        //         alert(data);
        //         return (data);
        //     }).catch(error => console.log(error));
        // },

        /**
         * method to remove fields
         */
        async remove(type,id){
            //get the ranking for scholarship
            let ranking_scholarship='';
            let std_id=this.student_form.student_id;
            let from_date = this.adm_start_date;
            let to_date = this.adm_end_date;
            await axios.get('/admissions/getScholarshipRanking/'+from_date+'/'+to_date+'/'+std_id)
            .then(Response =>{
                let data = Response;
                ranking_scholarship = data.data.data;
            }).catch(error => console.log(error));
            if(type == 'Accepted'){
                if(ranking_scholarship > this.scholarship_number){
                    Swal.fire({
                        text: "You are not eligible for scholarship. Do you want to proceed with your decision?",
                        icon: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes!',
                    }).then((result) => {
                        if(result.isConfirmed){
                            axios.get('/admissions/deleteclassDetails/'+id+'__'+type)
                            .then((response) => {
                                let data=response.data;
                                this.student_form.dzongkhag='';
                                this.student_form.school='';
                                this.student_form.class='';
                                // this.loadadmissions();
                            })
                            .catch((error) => {
                                console.log("Error remove:"+error);
                            })
                        }
                    });
                }
            } else {
                Swal.fire({
                    text: "Are you sure you want to proceed with your decision?",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!',
                }).then((result) => {
                    if(result.isConfirmed){
                        axios.get('/admissions/deleteclassDetails/'+id+'__'+type)
                        .then((response) => {
                            let data=response.data;
                            this.student_form.dzongkhag='';
                            this.student_form.school='';
                            this.student_form.class='';
                           
                           // this.loadadmissions();
                        })
                        .catch((error) => {
                            console.log("Error remove:"+error);
                        })
                    }
                });
            }
        },
        submitDetail(){
            Swal.fire({
                text: "Are you sure you wish to submit this details for further acceptance ?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
            }).then((result) => {
                if(result.isConfirmed){
                    this.student_form.post('/admissions/savefilanorgclassDetails')
                    .then((response) => {
                        let data=response.data;
                        this.$router.push({name:'acknowledgement'});
                    })
                    .catch((error) => {
                        console.log("Error addMore:"+error);
                    })
                }
            });
        },

        getdzongkhagList(type){
            let uri ='masters/loadGlobalMasters/all_active_dzongkhag';
            axios.get(uri)
            .then(Response =>{
                let data = Response.data.data;
                this.dzongkhagList = data;
                for(let i=0;i<data.length;i++){
                    this.dzongkhagArray[data[i].id] = data[i].name;
                }
                $('#dzongkhag').prop('disabled',false);
            }).catch(error => console.log(error));
        },

        getParentSchoolDzo(){
            this.student_form.dzongkhag = this.parent_school_dzongkhag;
            $('#dzongkhag').prop('disabled',true);
            this.getParentSchoolList(this.org_id);
        },

        getstudentPersonalDetails(type){
            axios.get('/admissions/getStudentDetailsFromPortal/'+type)
                .then(response => {
                let data = response.data;
                if(data != ""){
                    this.std_admission_details=data;
                    this.org_id = this.std_admission_details.OrgOrganizationId;
                    // let AdmissionType='';
                    // if(this.xi_admission_type=='Admission (XI-Gov Scholarship to Pvt. School)'){
                    //     $('#admission_message').html('The application is for Gov. Scholarship to Private School');

                    //     this.student_form.student_id=data.id;
                    //     this.loadadmissions();
                    //     this.student_form.admission_type=data.AdmissionType;
                    //     $("input[name=registrationType][value=" + data.AdmissionType + "]").prop('checked', true);
                    // } 
                    // else if(this.xi_admission_type=='Admission (XI-General)'){
                    //     $('#admission_message').html('General Admission for Class XI (includes both Public (within cluster) and Private School).');

                    //     let uri2 ='organizations/loadOrganizationDetailsbyOrgId/'+this.org_id;
                    //     axios.get(uri2)
                    //     .then(Response =>{
                    //         let dzongkhag_data = Response.data.data;
                    //         this.parent_school_dzongkhag = dzongkhag_data.dzongkhagId;
                    //         this.student_form.dzongkhag = this.parent_school_dzongkhag;
                    //         $('#dzongkhag').prop('disabled',true);
                    //         //this.getStudentClass(data.id);
                    //         this.getschoolList(this.parent_school_dzongkhag);
                    //     }).catch(error => console.log(error));

                    //     AdmissionType='ParentSchool';
                        
                    // } else if(this.xi_admission_type=='Admission (XI-Outside Cluster)'){
                    //     $('#admission_message').html('Application for Un-admitted Students to Schools outside of Cluster');
                    //     AdmissionType='Non-ParentSchool';
                        
                    // } else if(this.xi_admission_type=='Admission (XI-Increase in Capacity in School)'){
                    //     $('#admission_message').html('Admission for Un-admitted Students');
                    //     AdmissionType='Non-ParentSchool';
                        
                    // } else if(this.xi_admission_type=='Admission (XI-Unadmitted to Private Schools)'){
                    //     $('#admission_message').html('Admission for Un-admitted Students');
                    //     AdmissionType='Non-ParentSchool';

                    // } else {
                    //     $('#admission_message').html('Admissions for Class XI is Closed');
                    //     this.admission_closed=true;
                    // }
                    this.student_form.student_id=data.id;
                    // this.loadadmissions();
                    this.student_form.admission_type=data.AdmissionType;
                    $("input[name=registrationType][value=" + data.AdmissionType + "]").prop('checked', true);

                    this.showsection(data.AdmissionType)
                    this.getGewogList(data.CmnGewogId);
                    this.loadgewog(data.CmnGewogId);
                    this.getvillagelist(data.CmnGewogId,data.CmnChiwogId);

                    //Commented Code is old code

                    //Function to load the school list as per feeders
                    // if(type == 'Student'){
                    //     let uri2 ='organizations/loadOrganizationDetailsbyOrgId/'+this.org_id;
                    //     axios.get(uri2)
                    //     .then(Response =>{
                    //         let dzongkhag_data = Response.data.data;
                    //         this.parent_school_dzongkhag = dzongkhag_data.dzongkhagId;
                    //         this.student_form.dzongkhag = this.parent_school_dzongkhag;
                    //         $('#dzongkhag').prop('disabled',true);
                    //         this.getStudentClass(data.id);
                    //         this.getParentSchoolList(this.org_id);
                    //     }).catch(error => console.log(error));

                    //     this.student_form.student_id=data.id;
                    //     this.loadadmissions();
                    //     let AdmissionType='ParentSchool';
                    //     this.student_form.admission_type=AdmissionType;
                    //     $("input[name=registrationType][value=" + AdmissionType + "]").prop('checked', true);
                    // } else {
                    //     this.student_form.student_id=data.id;
                    //     this.loadadmissions();
                    //     this.student_form.admission_type=data.AdmissionType;
                    //     $("input[name=registrationType][value=" + data.AdmissionType + "]").prop('checked', true);
                    // }
                    // this.showsection(data.AdmissionType)
                    // this.getGewogList(data.CmnDzoId,data.CmnGewogId);
                    // this.getvillagelist(data.CmnGewogId,data.CmnChiwogId);
                }
                else{
                    $('#main_form').hide();
                    $('#message').html('You are not yet registered in the system. Please register your self first to proceed further from here. <br> Thank you!');
                    $('#screenPermission').show();
                }
            });
        },

        getStudentClass(std_id){
            let uri = '/students/getStudentClassId/'+ std_id;
            try{
                axios.get(uri).then(response => {
                    let data= response.data.data;
                    this.std_class=data.class;
                    this.classList.push(this.std_class);
                    $('#classsection').show();
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },

        getParentSchoolList(org_id){
            this.schoolList=[];
            let uri = '/organizations/loadParentSchoolList/'+ org_id;
            try{
                axios.get(uri).then(response => {
                    let data= response.data.data;
                    this.schoolList=data;
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },

        getclassList(id){
            this.classList =[];
            let orgId=$('#'+id).val();
            let schoolValue = this.checkSchoolList(orgId);
            if(schoolValue){
                this.student_form.school=orgId;
                axios.get('/masters/loadClassStreamSection/NA/' +orgId)
                .then(Response =>{
                    let data = Response.data;
                    let type=$('input[name="registrationType"]:checked').val();
                    this.student_form.admission_type=type;
                    this.classList = data;
                    $('#classsection').show();

                })
            } else {
                Swal.fire({
                    text: "This selection has already been added",
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok!',
                })
                this.student_form.school = '';
            }
        },

        checkSchoolList(orgId){
            for(let i=0;i<this.response_data.length;i++){
                if(this.response_data[i].organization.id == orgId){
                    return false;
                }
            }
            return true;
        },

        getstreamList(){
            let orgId=$('#school').val();
            if(this.xi_admission_type=='Admission (XI-Increase in Capacity in School)'){
                axios.get('/organizations/loadCapacityStream/' +orgId)
                .then(Response =>{
                    let data = Response.data;
                    this.streamList = data;
                })
                
            } else {
                axios.get('/masters/getStreamByOrgId/' +orgId)
                .then(Response =>{
                    let data = Response.data;
                    this.streamList = data;
                })
            }
            
        },

        checkStream(){
            let orgId=$('#school').val();
            let stream=$('#stream').val();
            for(let i=0;i<this.response_data.length;i++){
                if(this.response_data[i].OrgOrganizationId == orgId && this.response_data[i].stream_id == stream){
                    Swal.fire({
                    text: "This selection has already been added",
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok!',
                    })
                    this.student_form.stream = '';
                }
            }
        },

        getOrgDetails(id){
            axios.get('/organizations/loadOrganizationDetailsbyOrgId/' +id)
            .then(response =>{
                let data = response.data.data;
                this.OrgDetails=data;
            })

        },

        getGewogList(gewog_id){
            let uri = 'masters/all_active_dropdowns/dzongkhag/'+gewog_id;
            axios.get(uri)
            .then(response => {
                let data = response.data.data;
                for(let i=0;i<data.length;i++){
                    this.gewogArray[data[i].id] = data[i].name;
                }
                $('#gewogid').html(this.gewogArray[gewog_id]);
            });
        },
        loadgewog(gewogId){
            let uri = 'masters/load_gewog_details_by_id/'+gewogId;
            axios.get(uri)
            .then(response => {
                let data = response.data.data;
                this.gewog =  data;
                this.loaddzongkhag(data.dzongkhag_id);
            })
            .catch(function (error) {
            console.log('error: '+error);
            });
        },
        loaddzongkhag(dzo_id){
            let uri = 'masters/load_dzongkhag_details_by_id/'+dzo_id;
            axios.get(uri)
            .then(response => {
                let data = response.data.data;
                this.student_form.dzongkhagName =  data.name;
            })
            .catch(function (error) {
            console.log('error: '+error);
            });
        },


        getvillagelist(gewogId,vilId){
            let uri = 'masters/all_active_dropdowns/gewog/'+gewogId;
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                for(let i=0;i<data.length;i++){
                    this.villageArray[data[i].id] = data[i].name;
                }
                $('#vilageId').html(this.villageArray[vilId]);
            })
            .catch(function (error){
                console.log("Error:"+error)
            });
        },
        loadAdmissionDates(){
            this.classId = 'classXI';
            let uri = ('masters/loadAdmissionDates/'+this.classId);
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                if(data.length>0){
                    for(let obj of data){
                        if((obj.type ==  'Class XI( Arts )') && (new Date(obj.to_date) >= new Date(obj.cur_date)) && (new Date(obj.from_date) <= new Date(obj.cur_date))){
                        this.from_date = obj.from_date;
                        this.to_date = obj.to_date;
                            $('#admission_info').html('Admissions for Class XI( Arts ) is Opened');
                            break;
                        }
                        else if((obj.type ==  'Class XI( Science )') && (new Date(obj.to_date) >= new Date(obj.cur_date)) && (new Date(obj.from_date) <= new Date(obj.cur_date))){
                            this.from_date = obj.from_date;
                            this.to_date = obj.to_date;
                            $('#admission_info').html('Admissions for Class XI( Science ) is Opened');
                            break;
                        }
                        else if((obj.type == 'Class XI( Commerce )') && (new Date(obj.to_date) >= new Date(obj.cur_date)) && (new Date(obj.from_date) <= new Date(obj.cur_date))){
                            this.from_date = obj.from_date;
                            this.to_date = obj.to_date;
                            $('#admission_info').html('Admissions for Class XI( Commerce ) is Opened');
                            break;
                        }
                        else {
                            $('#admission_info').html('Admissions for Class XI is Closed');
                            $('#admission_message').html('Admissions for Class XI is Closed');
                            this.admission_closed=true;
                        }
                        
                    }
                }
                else{
                    $('#admission_info').html('Admissions for Class XI is Not Set');
                    $('#admission_message').html('Admissions for Class XI is Not Set');
                    this.admission_closed=true;
                }
            })
            .catch(function (error){
                console.log("Error:"+error)
            });
        },
        //TODO
        checkStudentAdmissionStatus(std_code){
            let uri='admissions/checkStudentAdmissionStatus/'+std_code;
            axios.get(uri)
            .then(response =>{
                let data = response.data;
                //this.positionResult = data;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },
        //TODO
        checkPassFail(std_code){
            let uri='admissions/checkPassFail/XI/'+std_code;
            axios.get(uri)
            .then(response =>{
                let data = response.data;
                //this.positionResult = data;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },
        applyselect(){
            if(!$('#dzongkhag').attr('class').includes('select2')){
            $('#dzongkhag').addClass('select2');
            }
            if(!$('#school').attr('class').includes('select2')){
            $('#school').addClass('select2');
            }
            if(!$('#class').attr('class').includes('select2')){
            $('#class').addClass('select2');
            }
            if(!$('#stream').attr('class').includes('select2')){
            $('#stream').addClass('select2');
            }
        },
        loadGenderList(uri="masters/loadGlobalMasters/all_active_gender"){
            axios.get(uri)
            .then(response => {
                let data = response;
                this.sex_idList =  data.data.data;
                for(let i=0;i<data.data.data.length;i++){
                    this.genderArray[data.data.data[i].id] = data.data.data[i].name;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        removeerror(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
            }
        },

        async changefunction(id){
            if($('#'+id).val()!=""){
                $('#'+id).removeClass('is-invalid');
                $('#'+id+'_err').html('');
                $('#'+id).addClass('select2');
            }
            if(id=="class"){
                this.student_form.class=$('#class').val();

            }
            if(id=="stream"){
                this.student_form.stream=$('#stream').val();
                // this.getstreamList($('#stream').val);
            }
        },

        getschoolList(dzo_id){
            if(dzo_id == 'dzongkhag'){
                dzo_id=$('#'+dzo_id).val();
            }
            var type;
            if(this.is_student){
                let AdmType = '';
                if(this.xi_admission_type=='Admission (XI-Gov Scholarship to Pvt. School)'){
                    if(this.response_data.length >0){
                        Swal.fire({
                        text: "Only a single application is accepted for Scholarship",
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok!',
                        })
                        this.student_form.dzongkhag = '';
                    }
                    AdmType='Scholarship';
                } else if(this.xi_admission_type=='Admission (XI-General)'){
                    AdmType='General';
                } else if(this.xi_admission_type=='Admission (XI-Outside Cluster)'){
                    AdmType='OutsideCluster';
                } else if(this.xi_admission_type=='Admission (XI-Increase in Capacity in School)'){
                    AdmType='IncreaseCapacity';
                } else if(this.xi_admission_type=='Admission (XI-Unadmitted to Private Schools)'){
                    AdmType='UnadmittedPrivate';
                }
                type = 'XI'+'__'+AdmType;
            } else{
                type=$('input[name="registrationType"]:checked').val();
            }

            this.schoolList=[];
            let uri = '/organizations/loadSchoolList/'+ dzo_id+'/'+type;
            try{
                axios.get(uri).then(response => {
                    let data= response.data.data;
                    this.schoolList=data;
                    $('#school_Section').show();
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },
        getProjection(){
            if($('input[name="registrationType"]:checked').val()=="PP"){
                let clasId=$('#class').val();
                let orgId=$('#school').val();
                let uri = '/organizations/loadProjection/'+clasId+'__'+orgId;
                axios.get(uri).then(response => {
                    let data= response.data;
                    this.student_form.seats=data.ProjectionNo;
                });
            }
            else{
                $('#seatAvailable').hide();
            }
        },
        loadVlidation(){
            let uri='masters/loadValidationcondition';
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                this.ppdob=data.date;
                this.eccddob=data.date1;
                this.ppmonth=data.no_months;
                this.eccdmonth=data.no_months1;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },

        loadQualificationMarks(){
            let uri='admissions/loadQualificationMarks';
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                for(let i=0;i<data.length;i++){
                    if(data[i].streamName=="Science"){
                        this.scienceQualification[data[i].subject_name]=data[i].marks;
                        this.scienceGrades[data[i].subject_name]=data[i].grade;
                    }
                    if(data[i].streamName=="Commerce"){
                        this.commerceQualification[data[i].subject_name]=data[i].marks;
                        this.commerceGrades[data[i].subject_name]=data[i].grade;
                    }
                    if(data[i].streamName=="Arts"){
                        this.artsQualification[data[i].subject_name]=data[i].marks;
                        this.artsGrades[data[i].subject_name]=data[i].grade;
                    }
                }                
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },

        loadScholarshipNumber(){
            let uri='admissions/loadScholarshipNumber';
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                let date = new Date();
                let present_year =date.getFullYear();
                for(let i=0;i<data.length;i++){
                    if(data[i].year == present_year){
                        this.scholarship_number = data[i].total_scholarships;
                    }
                }
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },

        loadStudentMarks(std_code){
            let uri='students/loadStudentMarks/'+std_code;
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                this.ppdob=data.date;
                this.eccddob=data.date1;
                this.ppmonth=data.no_months;
                this.eccdmonth=data.no_months1;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },

        loadResultPosition(std_code){
            let uri='admissions/loadResultPosition/'+std_code;
            axios.get(uri)
            .then(response =>{
                let data = response.data;
                this.positionResult = data;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },
        //TODO
        loadResults(std_code){
            let uri='admissions/loadResults/'+std_code;
            axios.get(uri)
            .then(response =>{
                let data = response.data;
                //this.positionResult = data;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },

        showsection(type){
            let dob=new Date(this.std_admission_details.DateOfBirth);
            // let year2=date2.getFullYear();
            // let month2=date2.getMonth();
            // let numberOfMonths;
            let isvalid=true;
            let messages="";
            if(type=="ECCD"){
                let date1=new Date(this.eccddob);
                // let year1=date1.getFullYear();
                // let month1=date1.getMonth();
                // if(month1===0){ //Have to take into account
                //     month1++;
                //     month2++;
                // }
                //numberOfMonths = (year2 - year1) * 12 + (month2 - month1) - 1;//excluding both month1 and month2
                // numberOfMonths = (year2 - year1) * 12 + (month2 - month1);//include either of the months
                //numberOfMonths = (year2 - year1) * 12 + (month2 - month1)+1;//include both of the months
                // if(this.eccdmonth>numberOfMonths){
                //     isvalid=false;
                // }
                if(date1<dob){
                    isvalid=false;
                }
                messages="You need to attend atleast "+this.eccdmonth+' months old to get register. You will attend that month only at '+this.y;
            }
            else{
                let date1=new Date(this.ppdob);
                // let year1=date1.getFullYear();
                // let month1=date1.getMonth();
                // if(month1===0){ //Have to take into account
                //     month1++;
                //     month2++;
                // }
               // numberOfMonths = (year2 - year1) * 12 + (month2 - month1) - 1;//excluding both month1 and month2
                // numberOfMonths = (year2 - year1) * 12 + (month2 - month1);//include either of the months
                //numberOfMonths = (year2 - year1) * 12 + (month2 - month1)+1;//include both of the months
                if(dob< date1){
                    isvalid=false;
                }
                messages="You need to attend atleast "+this.ppmonth+' months old to get register. You are eligible to register only at the total month of '+this.ppmonth;
            }
            if(isvalid){
                $('#selectschool').show();
                $('#validationmessages').hide();
            }else{
                $('#dzo_Section').hide();
                $('#seatAvailable').hide();
                $('#validation_message').html(messages);
                $('#validationmessages').show();
            }
        }
    },
    mounted() {
        this.loadStreamList();
        this.loadAdmissionDates();

        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.std_id=data['std_id'];
            let user_type=data['user_type'];
            if(data['user_type']!="Parent"){
                this.is_student=true;
            }
            this.getstudentPersonalDetails(user_type);
            this.getdzongkhagList(user_type);
            this.loadResultPosition(data['std_id']);
            this.loadResults(data['std_id']);
            this.checkStudentAdmissionStatus(data['std_id']);
            this.checkPassFail(data['std_id']);
        })
        .catch(errors => {
            console.log(errors)
        });

        $('.select2').select2({
        theme: 'bootstrap4'
        });
        $('.select2').on('select2:select', function (el){
            Fire.$emit('changefunction',$(this).attr('id'));
        });
        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });
        this.loadVlidation();
        this.loadGenderList();
        this.loadQualificationMarks();
        this.loadScholarshipNumber();
    },
}
</script> -->
